/**
 * Bandeau compact affiché quand des récurrences détectées auto attendent une action.
 *
 * Props :
 *   count   — nombre de récurrences pending
 *   onOpen  — callback () => void, ouvre PendingRecurrencesPanel
 */
export default function PendingRecurrencesBanner({ count, onOpen }) {
  if (!count || count <= 0) return null;

  return (
    <div
      id="pending"
      className="flex items-center justify-between gap-3 bg-amber-50 border border-amber-200 rounded-xl px-4 py-2.5 mb-4"
    >
      <p className="text-sm text-amber-800 font-medium">
        {count} récurrence{count > 1 ? 's' : ''} détectée{count > 1 ? 's' : ''} à valider
      </p>
      <button
        type="button"
        onClick={onOpen}
        className="shrink-0 text-sm font-semibold text-amber-700 hover:text-amber-900 underline underline-offset-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 rounded"
      >
        Voir
      </button>
    </div>
  );
}
